import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { QueryKeys } from '../../domain/QueryKeys';

import { CaseStudyEntry, getCaseStudies } from '@contentful/getCaseStudies';

export const useCaseStudies = (): UseQueryResult<CaseStudyEntry[]> => {
    return useQuery({
        queryKey: [QueryKeys.useCaseStudies],
        queryFn: async () => {
            const caseStudyData = await getCaseStudies();
            return caseStudyData;
        },
        enabled: true,
        staleTime: 5 * 60 * 60,
    });
};
